import { render, staticRenderFns } from "./TeacherLeaveEntitlement.vue?vue&type=template&id=1a70d451&scoped=true&"
import script from "./TeacherLeaveEntitlement.vue?vue&type=script&lang=js&"
export * from "./TeacherLeaveEntitlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a70d451",
  null
  
)

export default component.exports